import { DistributionChannel } from "@deliverr/replenishment-client";
import { isNil } from "lodash";

export const isDestinationFBA = (distributionChannel?: DistributionChannel) =>
  !isNil(distributionChannel) &&
  (distributionChannel === DistributionChannel.FBA_MANUAL || distributionChannel === DistributionChannel.FBA_V3);
